import React, { useState, useEffect, useContext } from "react";
import CardWrap from "../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { certificateService } from "../../Services/certificate.service";
import * as dateHelper from "../../Helpers/DateHelper";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const CertificateDetails = (props) => {
  let id = props.match.params.certificateId;
  const { locName, locTenant } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const [certificate, setCertificate] = useState({});

  useEffect(() => {
    certificateService
      .getById(id)
      .then((res) => setCertificate(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleToUpdate = () => {
    history.push(`/update-certificate/${id}`);
  };

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  return (
    <CardWrap subtitle={translator("Certificate-Details-Title")}>
      <div className="row pl-0">
        <div className="col-lg-3">
          <div className="custom-card m-2">
            <div className="custom-card-header">
              <h3>
                {certificate.name}{" "}
                <span className="button-edit">
                  {" "}
                  <i onClick={handleToUpdate} className="fas fa-pen">
                    {" "}
                  </i>
                </span>
              </h3>
              <hr />
            </div>
            <div className="custom-card-body">
              <p>
                <strong>{translator("Certificate-Detail-ValidFrom")}:</strong>{" "}
                {dateHelper.formatUtcToDate(certificate.validFrom)}
              </p>
              <p>
                <strong>{translator("Certificate-Detail-ValidTo")}:</strong>{" "}
                {dateHelper.formatUtcToDate(certificate.validTo)}
              </p>
            </div>
            <div className="custom-card-footer"></div>
          </div>
        </div>
        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={goBack}>
            {translator("Btn-Back")}
          </button>
        </div>
      </div>
    </CardWrap>
  );
};

export default CertificateDetails;
